var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlash(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 41,
    viewBox: "0 0 49 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2033 25.8133H17.5808V36.0133C17.5808 37.515 19.4508 38.2233 20.4425 37.09L31.1666 24.9066C32.1016 23.8441 31.3508 22.1866 29.9342 22.1866H25.5567V11.9866C25.5567 10.485 23.6866 9.77662 22.695 10.91L11.9708 23.0933C11.05 24.1558 11.8008 25.8133 13.2033 25.8133Z",
    stroke: "#163BA2",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0417 12.6666H2.125",
    stroke: "#163BA2",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.625 35.3334H2.125",
    stroke: "#163BA2",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.375 24H2.125",
    stroke: "#163BA2",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8652 11.3444C36.8652 12.3657 37.649 13.189 38.6227 13.189H40.6098C41.4569 13.189 42.1457 12.4686 42.1457 11.5819C42.1457 10.6161 41.7261 10.2757 41.1007 10.054L37.9102 8.94567C37.2848 8.724 36.8652 8.38359 36.8652 7.41775C36.8652 6.53109 37.554 5.81067 38.4011 5.81067H40.3882C41.3619 5.81067 42.1457 6.634 42.1457 7.65525",
    stroke: "#3C8DBC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5 4.75V14.25",
    stroke: "#3C8DBC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5 17.4167C43.8722 17.4167 47.4167 13.8723 47.4167 9.50004C47.4167 5.12779 43.8722 1.58337 39.5 1.58337C35.1277 1.58337 31.5833 5.12779 31.5833 9.50004C31.5833 13.8723 35.1277 17.4167 39.5 17.4167Z",
    stroke: "#3C8DBC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlash);
export default __webpack_public_path__ + "static/media/flash.8381f47261a77f409696af880d2f243a.svg";
export { ForwardRef as ReactComponent };